<template>
  <div>
    <div class="buttons">
      <a @click="$router.push('/')" class="back">
        <vk-icon icon="triangle-left" ratio="2"></vk-icon>
      </a>
      <span >リクエスト送信完了</span>
    </div>
    <div class="container">
      <p>リクエストメールを送信頂いた後に、自動で『リクエスト受付通知』をお送りいたしますので、内容をご確認ください。</p>
      <p>リクエスト受付通知のメールが届かない場合は、<a href="mailto:info@harigu.com">info@harigu.com</a>までご連絡願います。</p>
    </div>
    <div class="center-block">
      <button class="btn btn-secondary w-50" @click="$router.push('/')">TOPページへ</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ContributionSend',
  };
</script>

<style scoped lang="scss">
  .buttons {
    position: sticky;
    top: 48px;
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    z-index: 1;
    .back {
      color: rgb(240, 240, 240) !important;
      float: left;
      display: block;
    }
    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
    }
    &:after {
      clear: both;
    }
  }

  .container {
    padding: 1rem;
  }
  .center-block {
    text-align: center;
  }

</style>
